define( [
	"./cssExpand"
], function( cssExpand ) {
	"use strict";

	return new RegExp( cssExpand.join( "|" ), "i" );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/rboxStyle.js
// module id = 94
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21